import { COMBAT_MOOD, type CombatMoodConfig } from '../../../config/atmosphere/combatMood.config';

/**
 * CombatMoodModel — the pure combat-heat accumulator behind CombatMoodDriver.
 * No I/O, no events, no Pixi — just heat(0..1) → scene-mood multiplier, so the
 * mapping is fully unit-testable. The driver owns the event wiring + tick source.
 */
export class CombatMoodModel {
  private heat = 0; // 0..1

  constructor(private readonly cfg: CombatMoodConfig = COMBAT_MOOD) {}

  /** Register an ability cast — bumps heat toward 1 (capped). */
  onCast(): void {
    this.heat = Math.min(1, this.heat + this.cfg.bumpPerCast);
  }

  /** Advance time — bleed heat back toward 0. */
  tick(dtMs: number): void {
    if (dtMs <= 0) return;
    this.heat = Math.max(0, this.heat - (dtMs / 1000) * this.cfg.decayPerSec);
  }

  /** Current scene-mood multiplier: 1 (calm) → peak (full heat). */
  value(): number {
    return 1 + this.heat * (this.cfg.peak - 1);
  }

  /** Current heat 0..1 (tuner / tests). */
  get heatLevel(): number {
    return this.heat;
  }
}
